import { Helmet } from "react-helmet";

const defaultTitle = "Mohamed Gad | AI, Data Science, and Transportation Analytics Leader";
const defaultDescription =
  "Mohamed Gad blends AI, data science, and transportation analytics to build accountable systems for mobility, operations, and ethical automation.";
const defaultImage = "https://www.mohamedgad.com/mohamed-gad.png";
const defaultCanonical = "https://www.mohamedgad.com/";
const defaultKeywords = [
  "Mohamed Gad",
  "data science leader",
  "AI strategist",
  "transportation analytics",
  "ethical AI",
  "mobility systems",
  "operational analytics",
  "machine learning",
  "decision intelligence",
  "head of business intelligence"
];

/**
 * Reusable SEO head component to centralize meta, social cards, and JSON-LD.
 */
const SeoHead = ({
  title,
  description,
  keywords = [],
  canonical,
  image,
  type = "website",
  noIndex = false,
  jsonLd = [],
}) => {
  const mergedTitle = title ? `${title} | Mohamed Gad` : defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaCanonical = canonical || defaultCanonical;
  const mergedKeywords = [...defaultKeywords, ...keywords]
    .filter(Boolean)
    .join(", ");
  const robots = noIndex ? "noindex, nofollow" : "index, follow";
  const structuredData = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : [];

  return (
    <Helmet>
      <title>{mergedTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={mergedKeywords} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={metaCanonical} />

      <meta property="og:site_name" content="Mohamed Gad" />
      <meta property="og:title" content={mergedTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={metaCanonical} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={mergedTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:creator" content="@mohamedgad" />

      {structuredData.map((entry, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
